import React, { useState } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { useHooks } from "hooks";
import cx from "classnames";

import { Header, Navigation } from "components";
import useStore from "store";

const { Sider, Content } = Layout;

const App: React.FC = () => {
  const [collapsed, setCollapsed] = useState(true);
  const { system } = useStore();

  const { location, get } = useHooks()

  const pathname = get(location, 'pathname')

  return (
    <Layout className="h-full">
      <Sider
        trigger={null}
      // collapsible
      // collapsed={collapsed}
      // onMouseEnter={() => setCollapsed(false)}
      // onMouseLeave={() => setCollapsed(true)}
      >
        <Navigation />
      </Sider>
      <Layout>
        <Header />
        <Content className={pathname === '/chat' ? "overflow-auto p-[16px] min-h-[280px] bg-[#fff]" : "overflow-auto p-[16px] min-h-[280px]"}>
          <Outlet />
        </Content>
      </Layout>
    </Layout >
  );
};

export default App;
